import React from 'react';
import CustomerDataSection from './CustomerDataSection';
import apiService from '../../services/api';

const recordTypes = [
    {
        key: 'user_accounts',
        label: 'User Accounts',
        singularLabel: 'User Account',
        icon: 'bi-people',
        columns: [
            { key: 'id', label: 'ID', sortType: 'number' },
            { key: 'name', label: 'Name' },
            { key: 'user_name', label: 'Username' },
            { key: 'mobile', label: 'Mobile' },
            { key: 'last_updated_at', label: 'Last Updated', format: apiService.formatDateTime, sortType: 'date' },
        ],
        fetchRecords: (organizationId) => apiService.getArchivedPlatformUserProfiles(organizationId),
        restoreRecord: (id, ticketRef) => apiService.restorePlatformUserProfile(id, ticketRef),
    },
    {
        key: 'teams',
        label: 'Teams',
        singularLabel: 'Team',
        icon: 'bi-people-fill',
        columns: [
            { key: 'id', label: 'ID', sortType: 'number' },
            { key: 'name', label: 'Name' },
            { key: 'description', label: 'Description' },
            { key: 'last_updated_at', label: 'Last Updated', format: apiService.formatDateTime, sortType: 'date' },
        ],
        fetchRecords: (organizationId) => apiService.getArchivedPlatformTeams(organizationId),
        restoreRecord: (id, ticketRef) => apiService.restorePlatformTeam(id, ticketRef),
    },
    {
        key: 'storage_sites',
        label: 'Storage Sites',
        singularLabel: 'Storage Location',
        icon: 'bi-geo-alt',
        columns: [
            { key: 'id', label: 'ID', sortType: 'number' },
            { key: 'name', label: 'Name' },
            { key: 'last_updated_at', label: 'Last Updated', format: apiService.formatDateTime, sortType: 'date' },
        ],
        fetchRecords: (organizationId) => apiService.getArchivedStorageLocations(organizationId),
        restoreRecord: (id, ticketRef) => apiService.restoreStorageLocation(id, ticketRef),
    },
];

const ArchivedRecords = () => (
    <CustomerDataSection
        title="Archived Records"
        titleIcon="bi-archive"
        recordTypesLabel="Archived Record Types"
        recordTypes={recordTypes}
    />
);

export default ArchivedRecords;
